import { defineStore } from 'pinia';

export const useUtilStore = defineStore('util', () => {
    /** counter for fake ids */
    let fakeID = -1000;
    /**
     * Get a fake unique ID
     * @returns a fake ID
     */
    const nextFakeId = () => {
        fakeID--;
        return fakeID;
    };
    return { nextFakeId };
});
